//#region src/components/RRule/utils/get-orginal-num.ts
var getOrdinalNum = (n) => {
	const s = [
		"th",
		"st",
		"nd",
		"rd"
	];
	const v = n % 100;
	return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
//#endregion
export { getOrdinalNum };

//# sourceMappingURL=get-orginal-num.js.map